import api from "../../config/api";

const state = {
    calendarData: ''
}
const mutations = {
    SET_CALENDAR_DATA(state, payload) {
        state.calendarData = payload;
    },
}

const actions = {

    async getCalendar({ commit }, data) {

        const { personid, start, end } = data

        try {
            await api.get(`/activityinstancesresource?personid=${personid}&start=${start}&end=${end}`)
                .then((response) => {
                    commit('SET_CALENDAR_DATA', response.data);
                })
                .catch((error) => {
                    console.log("Error in fetching data", error);
                });
        } catch (error) {
            console.error('Error fetching API data:', error);
        }
    },

}

const getters = {
    stCalendarData: state => state.calendarData,
}

export default {
    state,
    mutations,
    actions,
    getters
}